import Vue from 'vue'
import productcontrols from './product-page-controls.vue'

const modal = new Vue({
    el: '.js-product-controls',
    components: {
      productcontrols
    }
});
